import { z } from "zod";

const emptyOrUrl = z.union([z.literal(""), z.url()]);

const envSchema = z.object({
  VITE_API_URL: emptyOrUrl.default(""),
  VITE_SENTRY_DSN: z.string().optional(),
  VITE_ENV: z.enum(["local", "dev", "staging", "prod"]).default("local"),
});

export const env = envSchema.parse(import.meta.env);
